import { ResponseDto } from '@diritto/common/base/response.dto';
import { NpsCampaignAnswerRequestDto } from '@diritto/common/dataAnalysis/dtos/nps-campaign.request.dto';
import {
  IsNpsCampaignAnsweredResponseDto,
  NpsCampaignResponseDto,
} from '@diritto/common/dataAnalysis/dtos/nps-campaign.response.dto';
import { Http } from '@diritto/common/utils/requester/http';

export class NpsCampaignApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getNpsCampaign() {
    const res = await this.http.get<NpsCampaignResponseDto>(`${this.url}/nps/campaign`);
    return res.data;
  }

  async getIsNpsCampaignAnswered(npsCampaignId: number) {
    const res = await this.http.get<IsNpsCampaignAnsweredResponseDto>(
      `${this.url}/nps/campaigns/${npsCampaignId}/answer`,
    );
    return res.data;
  }

  async answerNpsCampaign(npsCampaignId: number, npsCampaignAnswerRequestDto: NpsCampaignAnswerRequestDto) {
    const res = await this.http.post<NpsCampaignAnswerRequestDto, ResponseDto>(
      `${this.url}/nps/campaigns/${npsCampaignId}/answer`,
      npsCampaignAnswerRequestDto,
    );
    return res.data;
  }
}
